import { isArray } from '../shortcut'

import type {
  MixtureClassDecorator,
  TakeArgs,
  TClass,
  TFunction,
  TNil
} from '../types'

interface IClassDecoratorContext<
  T extends any[] = any[],
  U extends any[] = any[]
> {
  argsProcess?(...args: T): TNil | U
  esDecorator?<T extends TClass>(
    constructor: T,
    context: ClassDecoratorContext<T>,
    ...args: U
  ): T | TNil
  tsDecorator?<T extends TClass>(constructor: T, ...args: U): T | TNil
}

export function createClassDecorator<T = [], U = T>(
  context: IClassDecoratorContext<TakeArgs<T>, TakeArgs<U>>
): T extends TFunction ? T : (...args: TakeArgs<T>) => MixtureClassDecorator
export function createClassDecorator(context: IClassDecoratorContext): any {
  return (...args: any[]) => {
    if (context.argsProcess !== undefined) {
      const processed = context.argsProcess(...args)
      if (isArray(processed)) args = processed
      else return
    }
    return (arg1: any, arg2?: any) => {
      if (arg2 === undefined) {
        if (context.tsDecorator === undefined)
          throw new Error('The decorator is not supported here.')
        return context.tsDecorator(arg1, ...args)
      } else {
        if (context.esDecorator === undefined)
          throw new Error('The decorator is not supported here.')
        return context.esDecorator(arg1, arg2, ...args)
      }
    }
  }
}
